import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AiOutlineMail } from "react-icons/ai";
import { LiaWhatsapp } from "react-icons/lia";
import { FaFilePdf, FaMobileAlt } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import { FaTimesCircle } from "react-icons/fa";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import accountDeleted from "../../../../../images/accountDelete.png";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import { getFullName } from "../../../../../helpers/CommonHelper";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import Details from "../../../memberCars/partials/details/Details";
import ReactFancyBox from "react-fancybox";
import MemberStatusBadge from "../MemberStatusBadge";
const DetailsSignup = ({
  item,
  moduleConfig,
  confirmAndDelete,
  confirmAndBlock,
  confirmAndUnblock,
  customButtonsForItems,
}) => {
  var serverUploadsUrl = process.env.REACT_APP_BACKEND_URL + "public/";
  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];
    if (item.email) {
      items = [...items, { text: "Email", value: item.email, type: "email" }];
    }
    if (item.mobile) {
      items = [...items, { text: "Mobile", value: item.mobile, type: "phone" }];
    }
    if (item.nationality) {
      items = [
        ...items,
        { text: "Nationality", value: item.nationality, type: "text" },
      ];
    }
    if (item.dob) {
      items = [
        ...items,
        { text: "Date of Birth", value: item.dob, type: "text" },
      ];
    }

    if (item.referredBy) {
      items = [
        ...items,
        { text: "Referred By", value: item.referredBy, type: "text" },
      ];
    }
    if (item.referredName) {
      items = [
        ...items,
        { text: "Referred Name", value: item.referredName, type: "text" },
      ];
    }
    if (item.status === "Member" && item.joiningDate) {
      items = [
        ...items,
        { text: "Member Since", value: item.joiningDate, type: "text" },
      ];
    }

    if (item.createdAt) {
      items = [
        ...items,
        { text: "Profile Created On", value: item.createdAt, type: "text" },
      ];
    }

    if (
      item.otherClub &&
      item.otherClub.enrolled === "1" &&
      item.otherClub.otherClub
    ) {
      items = [
        ...items,
        {
          text: "Other Club Membership",
          value: item.otherClub.otherClub,
          type: "text",
        },
      ];
    }

    if (item.about) {
      items = [...items, { text: "About", value: item.about, type: "text" }];
    }
    if (item.job) {
      if (item.job.occupation) {
        items = [
          ...items,
          {
            text: "Occupation",
            value: item.job.occupation,
            type: "text",
          },
        ];
      }
      if (item.job.company) {
        items = [
          ...items,
          { text: "Company Name", value: item.job.company, type: "text" },
        ];
      }

      if (item.job.address) {
        items = [
          ...items,
          {
            text: "Comapny address",
            value: item.job.address,
            type: "text",
          },
        ];
      }
    }

    return items;
  };

  return (
    <>
      <Card className={`item mb-2 memberItem`}>
        {item.accountDeletionRequested === "1" ||
        item.accountDeletionRequested === 1 ||
        item.accountDeletionRequested === true ? (
          <>
            <div
              className={` ${
                item.accountDeletionRequested === "1" ||
                item.accountDeletionRequested === 1 ||
                item.accountDeletionRequested === true
                  ? "accountDeleted"
                  : ""
              }`}
            ></div>
          </>
        ) : null}
        <Card.Header
          className={`ps-1 pe-xl-0 pe-2 py-0  ${
            item.accountDeletionRequested === "1" ||
            item.accountDeletionRequested === 1 ||
            item.accountDeletionRequested === true
              ? "accountDeletedBg"
              : ""
          }`}
        >
          <Card.Title className="m-0 p-0 ">
            <div className="d-flex ImageSectionSpacing">
              <div className="position-relative ms-1 me-2">
                {/* {item.isChairman === "1" ||
                  item.isChairman === 1 ||
                  item.isChairman === true ? (
                  <div className="chairmanStatus">
                    <i
                      class="fa fa-star"
                      aria-hidden="true"
                      title={`${getFullName(item)
                        } is Chairman`}
                    ></i>
                  </div>
                ) : null} */}
                {item.accountDeletionRequested === "1" ||
                item.accountDeletionRequested === 1 ||
                item.accountDeletionRequested === true ? (
                  <div className="accountDeleteIcon">
                    <i
                      class="fa fa-trash"
                      aria-hidden="true"
                      title={`${getFullName(
                        item,
                      )} requested for account deletion`}
                    ></i>
                  </div>
                ) : null}

                {item.accountDeletionRequested === "1" ||
                item.accountDeletionRequested === 1 ||
                item.accountDeletionRequested === true ? null : (
                  <>
                    {item.isLoggedIn === "1" ||
                    item.isLoggedIn === 1 ||
                    item.isLoggedIn === true ? (
                      <div className="activeStatus"></div>
                    ) : (
                      <div className="notActiveStatus"></div>
                    )}
                  </>
                )}
                <>
                  {item.image ? (
                    <Image
                      src={
                        process.env.REACT_APP_BACKEND_URL +
                        "public/" +
                        item.image
                      }
                      width="52px"
                      height="52px"
                      className="border rounded-circle"
                    />
                  ) : (
                    <Image
                      src={memberDummyImage}
                      width="45px"
                      className="border rounded-circle"
                    />
                  )}
                </>

                {item.blockedByAdmin === "1" && (
                  <i className="fas fa-ban position-absolute  banned2"> </i>
                )}
              </div>

              <div className="d-flex flex-column ms-1">
                <span className="m-0 text-bold memberName ">
                  {getFullName(item)}
                  {console.log(item.cars)}

                  {item.role === "Board Member" ? (
                    <span className="boardMemberText">{item.role}</span>
                  ) : item.role === "Club President" ? (
                    <span className="greenBackgroundText">{item.role}</span>
                  ) : item.role === "Club Vice President" ? (
                    <span className="greenBackgroundText">{item.role}</span>
                  ) : item.role === "Member" ? null : (
                    <span className="normalText">({item.role})</span>
                  )}

                  {/* {item.hasCMSAccess === "1" && (
                    <span className="hasCMSAccessText">Has CMS Access</span>
                  )}

                  {item.allowedToViewMemberDetails === "1" && (
                    <span className="hasMemberDetailsAccessText"> Has Member Details Access</span>
                  )} */}
                </span>

                <span className="font-italic font-small font-weight-normal text-success fs-8 mt-1  ">
                  {/* {item.oldMemberNumber && (
                    <span className="membershipId">
                      ({item.oldMemberNumber})
                    </span>
                  )} */}

                  <MemberStatusBadge member={item} />
                </span>
              </div>
            </div>
          </Card.Title>

          <div className="card-tools">
            <div className=" text-right  mt-0 me-xl-2">
              {item.expiryStatus === "membershipIsExpired" && (
                <>
                  <Badge bg="danger">Expired</Badge>{" "}
                </>
              )}
              {item.expiryStatus === "membershipIsInTolerancePeriod" && (
                <>
                  <Badge bg="warning">Tolerance Period</Badge>{" "}
                </>
              )}

              {item.expiryStatus === "membershipIsExpiringSoon" && (
                <>
                  <Badge bg="secondary">Expiring Soon</Badge>{" "}
                </>
              )}

              {item.migratedMember === "1" && (
                <>
                  <Badge bg="info" className="me-1">
                    Migrated Member
                  </Badge>{" "}
                </>
              )}

              {item.createdByAdmin === "1" && (
                <>
                  <Badge bg="primary" className="me-1">
                    Admin Created Profile
                  </Badge>{" "}
                </>
              )}
              {item.createdByAdmin === "0" && item.migratedMember === "0" && (
                <>
                  <Badge bg="purple" className="me-0">
                    Mobile App Signup
                  </Badge>{" "}
                </>
              )}
              {item.accountDeletionRequested === "1" ||
              item.accountDeletionRequested === 1 ||
              item.accountDeletionRequested === true ? (
                <Badge bg="dark" className="ms-2 me-xl-1 resubmission">
                  Account Deletion Requested
                </Badge>
              ) : null}
              {/* {item.status === "Member" && item.joiningDate && (
                <>
                  <Badge bg="success">Member Since: {item.joiningDate}</Badge>{" "}
                </>
              )}

              {item.createdAt && (
                <>
                  <Badge bg="warning">
                    Profile Created On: {item.createdAt}
                  </Badge>{" "}
                </>
              )} */}
            </div>

            <div className=" text-right  mt-0 me-xl-2">
              <span className="badge badge-light me-1 text-dark">
                Agreed With Terms :{" "}
                <span class="text-secondary">
                  <ModuleDisplayBoolean value={item.agreedWithTerms} />{" "}
                </span>
              </span>
              <span className="badge badge-light me-1 text-dark">
                Email Verified :{" "}
                <span class="text-secondary">
                  <ModuleDisplayBoolean value={item.emailVerified} />{" "}
                </span>
              </span>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="py-0 px-0">
          <Row className="w-100 mx-auto">
            {(item.accountDeletionRequested === "1" ||
              item.accountDeletionRequested === 1 ||
              item.accountDeletionRequested === true ||
              item.rejectionReason ||
              item.blockedByAdmin === "1" ||
              (item.stats && item.stats.cars <= 0) ||
              (item.carConflicts && item.carConflicts.length > 0)) && (
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="ps-0 pr-0"
              >
                {item.accountDeletionRequested === "1" ||
                item.accountDeletionRequested === 1 ||
                item.accountDeletionRequested === true
                  ? item.accountDeletionReason && (
                      <Alert variant="dark mt-1 mb-0 p-0  font-small mx-1 px-1">
                        <p className="mb-0 text-bold font-small">
                          Account Deletion Reason :
                          <span className="mb-0 text-normal ps-2">
                            {item.accountDeletionReason}
                          </span>
                        </p>
                      </Alert>
                    )
                  : null}
                {item.rejectionReason &&
                  (item.status === "SignupRequest" ||
                    item.status === "SignupRequestRejected") && (
                    <Alert variant="danger mx-1 mt-1 mb-0 p-1 font-small px-1">
                      <p className="mb-0 text-bold font-small">
                        {(item.resubmission === "1" ? "Previous " : "") +
                          "Rejection Reason"}{" "}
                        :
                        <span className="mb-0 text-normal ps-2">
                          {item.rejectionReason}
                        </span>
                      </p>
                    </Alert>
                  )}
                {item.blockedByAdmin === "1" && item.blockReason && (
                  <Alert variant="danger mx-1 mt-1 mb-0 p-1 font-small">
                    <p className="mb-0 text-bold font-small">
                      Block Reason :
                      <span className="mb-0 text-normal ps-2">
                        {item.blockReason}
                      </span>
                    </p>
                  </Alert>
                )}
                {item.stats && item.stats.cars <= 0 && (
                  <Alert variant="warning mx-1 mt-1 mb-0 p-1 font-small">
                    <p className="mb-0 text-bold font-small">
                      <span className="mb-0 text-normal ps-2">
                        This member doesn't have an active car.{" "}
                        {item.lastCarDeletedOn &&
                          item.lastCarDeletedOn.deletionDate && (
                            <>
                              Last car deleted on{" "}
                              <span className="text-bold">
                                <ModuleDisplayDate
                                  value={item.lastCarDeletedOn.deletionDate}
                                />
                              </span>
                            </>
                          )}
                      </span>
                    </p>
                  </Alert>
                )}
                {item.carConflicts && item.carConflicts.length === 1 && (
                  <div className="warningDark mx-1 mt-1 mb-0 p-1 font-small">
                    <p className="mb-0 text-bold font-small">
                      <span className="mb-0 text-normal ps-2">
                        This member has a conflict with his/her car "
                        {item.carConflicts[0].model}"
                        {item.carConflicts[0] &&
                          item.carConflicts[0].conflictReason && (
                            <span className="text-bold ps-2 mb-0">
                              Conflict Reason:
                              <span className="mb-0 text-normal ps-2">
                                {item.carConflicts[0].conflictReason}
                              </span>
                            </span>
                          )}
                      </span>
                    </p>
                  </div>
                )}
                {item.carConflicts && item.carConflicts.length > 1 && (
                  <div className="warningDark mx-1 mt-1 mb-0 p-1 font-small">
                    <p className="mb-0 text-bold font-small">
                      <span className="mb-0 text-normal ps-2">
                        This member has a conflict with his/her car.
                      </span>
                    </p>
                  </div>
                )}
              </Col>
            )}

            <Col
              xl={4}
              lg={3}
              md={6}
              sm={8}
              xs={12}
              className="position-relative ps-0 px-2 my-2 mx-0"
            >
              <Card>
                <Card.Body className="py-0 px-3">
                  <>
                    <div className="carDetailsHead">Personal Details</div>
                    {item.email && (
                      <div className="displayRow mt-4 ">
                        <div className="leftText">Email :</div>
                        <div className="rightText">
                          <p className="mb-0 linkDisplay">
                            <ModuleDisplayEmail value={item.email} />
                          </p>
                        </div>
                      </div>
                    )}
                    {item.mobile && (
                      <div className="displayRow ">
                        <div className="leftText">Mobile :</div>
                        <div className="rightText">
                          <p className="mb-0 linkDisplay">
                            <ModuleDisplayPhone value={item.mobile} />
                          </p>
                        </div>
                      </div>
                    )}
                    {/* {item.emiratesID &&
                  <div className="displayRow ">
                    <div className="leftText">Emirates ID :</div>
                    <div className="rightText">
                      <p className="mb-0"><ModuleDisplayPhone value={item.emiratesId} /></p>
                    </div>
                  </div>} */}
                    {item.nationality && (
                      <div className="displayRow ">
                        <div className="leftText">Nationality :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.nationality}</p>
                        </div>
                      </div>
                    )}
                    {item.dob && (
                      <div className="displayRow ">
                        <div className="leftText">Date of Birth :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.dob}</p>
                        </div>
                      </div>
                    )}
                    {item.referredBy && (
                      <div className="displayRow ">
                        <div className="leftText">Referred By :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.referredBy}</p>
                        </div>
                      </div>
                    )}
                    {item.referredName && (
                      <div className="displayRow ">
                        <div className="leftText">Referred Name :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.referredName}</p>
                        </div>
                      </div>
                    )}
                    {item.createdAt && (
                      <div className="displayRow ">
                        <div className="leftText">Profile Created On :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.createdAt}</p>
                        </div>
                      </div>
                    )}
                    {item.job && item.job.occupation && (
                      <div className="displayRow ">
                        <div className="leftText">Occupation :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.job.occupation}</p>
                        </div>
                      </div>
                    )}
                  </>
                </Card.Body>
              </Card>
            </Col>
            {item.modeOfComm && (
              <Col xl={4} lg={2} md={5} sm={4} xs={12} className="my-2">
                <Card>
                  <Card.Body className="p-2">
                    <div className="carDetailsHead">Mode of Communication</div>
                    <Card className="mt-4 mb-1">
                      <Card.Body className="px-2 py-2">
                        <div className="carTopHolder mb-0 border-0 pb-0">
                          <div className="carLeftHolder">
                            <AiOutlineMail className="mx-2" /> Email
                          </div>
                          <div className="carRightHolder">
                            {item.modeOfComm.email ? (
                              <FaCircleCheck className="text-success" />
                            ) : (
                              <FaTimesCircle className="text-danger" />
                            )}
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                    <Card className="mt-0 mb-1">
                      <Card.Body className="px-2 py-2">
                        <div className="carTopHolder mb-0 border-0 pb-0">
                          <div className="carLeftHolder">
                            <LiaWhatsapp className="mx-2" /> Whatsapp
                          </div>
                          <div className="carRightHolder">
                            {item.modeOfComm.whatsApp ? (
                              <FaCircleCheck className="text-success" />
                            ) : (
                              <FaTimesCircle className="text-danger" />
                            )}
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                    <Card className="mt-0 mb-1">
                      <Card.Body className="px-2 py-2">
                        <div className="carTopHolder mb-0 border-0 pb-0">
                          <div className="carLeftHolder">
                            <FaMobileAlt className="mx-2" /> Mobile App
                          </div>
                          <div className="carRightHolder">
                            {item.modeOfComm.mobileApp ? (
                              <FaCircleCheck className="text-success" />
                            ) : (
                              <FaTimesCircle className="text-danger" />
                            )}
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Card.Body>
                </Card>
              </Col>
            )}
            {item.emiratesIdFront && item.emiratesIdBack && (
              <Col xl={4} lg={4} md={5} sm={6} xs={12} className="my-2">
                <Card>
                  <Card.Body className="px-0 pb-0">
                    <div className="carDetailsHead">Emirates ID</div>

                    {item.emiratesIdFront.toLowerCase().endsWith(".pdf") ? (
                      <div className="carTopHolder pb-0  pb-2 pt-3 px-3">
                        <div className="carLeftHolder">
                          <div className="align-items-center d-flex py-0 mb-0 px-0 justify-content-center">
                            <a
                              href={`${serverUploadsUrl}${item.emiratesIdFront}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-info fontItalic"
                            >
                              View Emirates ID (Front) PDF
                            </a>
                          </div>
                        </div>
                        <div className="carRightHolder">
                          <FaFilePdf className="text-danger" />
                        </div>
                      </div>
                    ) : (
                      <div className="align-items-center d-flex py-2 mb-0 px-0 justify-content-center">
                        <div className="emiratesId">
                          <ReactFancyBox
                            thumbnail={`${serverUploadsUrl}${item.emiratesIdFront}`}
                            image={`${serverUploadsUrl}${item.emiratesIdFront}`}
                          />
                        </div>
                      </div>
                    )}

                    {item.emiratesIdBack.toLowerCase().endsWith(".pdf") ? (
                      <div className="carTopHolder pb-0  border-0 py-2 px-3">
                        <div className="carLeftHolder">
                          <div className="align-items-center d-flex py-0 mb-0 px-0 justify-content-center">
                            <a
                              href={`${serverUploadsUrl}${item.emiratesIdBack}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-info fontItalic"
                            >
                              View Emirates ID (Back) PDF
                            </a>
                          </div>
                        </div>
                        <div className="carRightHolder">
                          <FaFilePdf className="text-danger" />
                        </div>
                      </div>
                    ) : (
                      <div className="align-items-center d-flex py-2 mb-0 px-0 justify-content-center">
                        <div className="emiratesId">
                          <ReactFancyBox
                            thumbnail={`${serverUploadsUrl}${item.emiratesIdBack}`}
                            image={`${serverUploadsUrl}${item.emiratesIdBack}`}
                          />
                        </div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            )}
            {item.cars && item.cars.length > 0 && (
              <Col
                xl={"auto"}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="pr-0 px-2 position-relative border-left my-2"
              >
                <Card>
                  <Card.Body className="m-0 px-2 py-0">
                    <Row>
                      {item.cars.map((car, index) => {
                        return (
                          <>
                            {index === 0 && (
                              <div className="carDetailsHead">Car Details</div>
                            )}
                            <Col
                              xl={item.cars.length > 2 ? 4 : "auto"}
                              className={
                                index !== item?.cars?.length - 1
                                  ? "border-end px-4"
                                  : " px-4"
                              }
                            >
                              <div
                                className={
                                  car.model || car.color || car.year
                                    ? "carTopHolder mt-4"
                                    : "carTopHolder border-0 mt-1"
                                }
                              >
                                {(car.model || car.color || car.year) && (
                                  <>
                                    <div className="carLeftHolder">
                                      {car.model && (
                                        <p className="model mb-0">
                                          {car.model}
                                        </p>
                                      )}
                                      {car.color && (
                                        <p className="color mb-0">
                                          {car.color}
                                        </p>
                                      )}
                                    </div>

                                    <div className="carRightHolder">
                                      {car.year && (
                                        <p className="year mb-0">{car.year}</p>
                                      )}
                                    </div>
                                  </>
                                )}
                              </div>
                              <div className="displayRow ">
                                <div className="leftText">Chassis Number :</div>
                                <div className="rightText">
                                  <p className="mb-0">{car.chassisNumber}</p>
                                </div>
                              </div>
                              {car.emirate && (
                                <div className="displayRow ">
                                  <div className="leftText">Emirate :</div>
                                  <div className="rightText">
                                    <p className="mb-0">{car.emirate}</p>
                                  </div>
                                </div>
                              )}
                              {car.dateOfPurchase && (
                                <div className="displayRow">
                                  <div className="leftText">
                                    Date of Purchase :
                                  </div>
                                  <div className="rightText">
                                    <p className="mb-0">
                                      <ModuleDisplayDate
                                        value={car.dateOfPurchase}
                                      />
                                    </p>
                                  </div>
                                </div>
                              )}
                              {car.purchaseFrom && (
                                <div className="displayRow">
                                  <div className="leftText">
                                    Purchased From :
                                  </div>
                                  <div className="rightText">
                                    <p className="mb-0">{car.purchaseFrom}</p>
                                  </div>
                                </div>
                              )}
                              {car.plateNumber && (
                                <div className="displayRow">
                                  <div className="leftText">Plate Number :</div>
                                  <div className="numberPlate">
                                    <p className="mb-0">{car.plateNumber}</p>
                                  </div>
                                </div>
                              )}
                              {(car.registrationCard ||
                                car.registrationCardBack) && (
                                <div className="displayRow2">
                                  <div className="leftText">
                                    Registration Card :
                                  </div>
                                  <div className="row w-100 ">
                                    {car.registrationCard && (
                                      <Col lg={6} xl={6} md={6}>
                                        <Card className="align-items-center mt-2 d-flex py-2 mb-0  px-3 justify-content-center">
                                          <div className="registrationCard">
                                            <ReactFancyBox
                                              thumbnail={`${serverUploadsUrl}${car.registrationCard}`}
                                              image={`${serverUploadsUrl}${car.registrationCard}`}
                                            />
                                          </div>
                                        </Card>
                                      </Col>
                                    )}

                                    {car.registrationCardBack && (
                                      <Col lg={6} xl={6} md={6}>
                                        <Card className="align-items-center mt-2 d-flex py-2 mb-0  px-3 justify-content-center">
                                          <div className="registrationCard">
                                            <ReactFancyBox
                                              thumbnail={`${serverUploadsUrl}${car.registrationCardBack}`}
                                              image={`${serverUploadsUrl}${car.registrationCardBack}`}
                                            />
                                          </div>
                                        </Card>
                                      </Col>
                                    )}
                                  </div>
                                </div>
                              )}
                            </Col>
                          </>
                        );
                      })}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default DetailsSignup;
